import {createAction, props} from '@ngrx/store';
import {ResearchKeywordCreateDTO, ResearchKeywordDTO} from '../../dto/research-keywords';

export const loadResearchKeywords = createAction(
  '[ResearchKeyword] Load ResearchKeywords',
  props<{ projectId: number }>()
);
export const loadResearchKeywordsSuccess = createAction(
  '[ResearchKeyword] Load ResearchKeywords Success',
  props<{ keywords: ResearchKeywordDTO[] }>()
);
export const loadResearchKeywordsFailure = createAction(
  '[ResearchKeyword] Load ResearchKeywords Failure',
  props<{ error: any }>()
);

export const createResearchKeyword = createAction(
  '[ResearchKeyword] Create ResearchKeyword',
  props<{ projectId: number; keyword: ResearchKeywordCreateDTO; updateLinkedQueries: boolean }>()
);
export const createResearchKeywordSuccess = createAction(
  '[ResearchKeyword] Create ResearchKeyword Success',
  props<{ keyword: ResearchKeywordDTO }>()
);
export const createResearchKeywordFailure = createAction(
  '[ResearchKeyword] Create ResearchKeyword Failure',
  props<{ error: any }>()
);

export const generateResearchKeyword = createAction(
  '[ResearchKeyword] Generate ResearchKeyword',
  props<{ projectId: number; }>()
);
export const generateResearchKeywordSuccess = createAction(
  '[ResearchKeyword] Generate ResearchKeyword Success',
  props<{ projectId: number, keywords: ResearchKeywordDTO[] }>()
);
export const generateResearchKeywordFailure = createAction(
  '[ResearchKeyword] Generate ResearchKeyword Failure',
  props<{ error: any }>()
);


export const deleteResearchKeyword = createAction(
  '[ResearchKeyword] Delete ResearchKeyword',
  props<{ projectId: number; id: number; updateLinkedQueries: boolean }>()
);
export const deleteResearchKeywordSuccess = createAction(
  '[ResearchKeyword] Delete ResearchKeyword Success',
  props<{ id: number }>()
);
export const deleteResearchKeywordFailure = createAction(
  '[ResearchKeyword] Delete ResearchKeyword Failure',
  props<{ error: any }>()
);

export const retrieveResearchKeyword = createAction(
  '[ResearchKeyword] Retrieve ResearchKeyword',
  props<{ projectId: number; id: number }>()
);
export const retrieveResearchKeywordSuccess = createAction(
  '[ResearchKeyword] Retrieve ResearchKeyword Success',
  props<{ keyword: ResearchKeywordDTO }>()
);
export const retrieveResearchKeywordFailure = createAction(
  '[ResearchKeyword] Retrieve ResearchKeyword Failure',
  props<{ error: any }>()
);

export const updateResearchKeyword = createAction(
  '[ResearchKeyword] Update ResearchKeyword',
  props<{ projectId: number; id: number; keyword: ResearchKeywordDTO; updateLinkedQueries: boolean }>()
);
export const updateResearchKeywordSuccess = createAction(
  '[ResearchKeyword] Update ResearchKeyword Success',
  props<{ keyword: ResearchKeywordDTO }>()
);
export const updateResearchKeywordFailure = createAction(
  '[ResearchKeyword] Update ResearchKeyword Failure',
  props<{ error: any }>()
);
